import React from "react";
import InvoiceGenerated from "../InvoiceGenerated";

const InvoiceGeneratedComponent = () => {
  return <InvoiceGenerated status="class-allocated" title="class-allocated" />;
};

export default InvoiceGeneratedComponent;
